export default {
	'blog': 'Blog Settings',
	'blog-desc': 'Detailed blog settings.',
	'profile': 'Account Settings',
	'profile-desc': 'Account and Github settings.',
};
